import classNames from "classnames";
import React, { InputHTMLAttributes } from "react";

export type InputProps = InputHTMLAttributes<HTMLInputElement> & {
    invalid?: boolean;
    valid?: boolean;
    className?: string;
    bsSize?: string;
    size?: string;
    addon?: boolean;
    plaintext?: boolean;
    innerRef?: React.Ref<HTMLInputElement>;
};

const Input = ({
    valid,
    invalid,
    type = "text",
    className,
    bsSize,
    addon,
    plaintext,
    innerRef,
    ...attributes
}: InputProps) => {
    const checkInput = ["radio", "checkbox"].indexOf(type) > -1;
    const isNotaNumber = new RegExp("\\D", "g");

    const fileInput = type === "file";
    const rangeInput = type === "range";

    let formControlClass: string | null = "form-control";

    if (plaintext) {
        formControlClass = `${formControlClass}-plaintext`;
    } else if (fileInput) {
        formControlClass = `${formControlClass}-file`;
    } else if (rangeInput) {
        formControlClass = `${formControlClass}-range`;
    } else if (checkInput) {
        if (addon) {
            formControlClass = null;
        } else {
            formControlClass = "form-check-input";
        }
    }

    if (attributes.size && isNotaNumber.test(attributes.size)) {
        bsSize = attributes.size;
        delete attributes.size;
    }

    const classes = classNames(
        className,
        invalid && "is-invalid",
        valid && "is-valid",
        bsSize ? `form-control-${bsSize}` : false,
        formControlClass,
    );

    if (attributes.children && !plaintext) {
        //@ts-ignore
        delete attributes.children;
    }

    return (
        <input
            aria-invalid={invalid}
            className={classes}
            ref={innerRef}
            type={type}
            {...attributes}
        />
    );
};

export { Input };
